exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pagination-parent span[data-v-74deaff6]{padding:0 5px}.pagination[data-v-74deaff6]{border-color:#e9e9e9;margin-top:0;margin-bottom:5px;height:40px;padding-left:5px}.grid-component-components[data-v-74deaff6]{padding-top:10px;position:sticky;bottom:0;background-color:#fff}.grid-component-components>div[data-v-74deaff6]{margin-right:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-74deaff6&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GridComponent.vue
// module id = 916
// module chunks = 2